import gql from 'graphql-tag';

export default gql`
query getChangelogEntries($limit: Int!, $audiences: [String!]) {
  changelog_entries(
    where: {audience: {_in: $audiences}},
    order_by: [{published_at: desc}, {slug: asc}],
    limit: $limit
  ) {
    slug
    published_at
    created_at
    version
    category
    title_de
    title_en
    teaser_de
    teaser_en
    help_url
    image_url
  }
}
`;
